<template>
  <div class="c-modal assignee-modal" v-show="visible">
    <div class="c-modal-content position-relative">
      <div class="c-modal-header">
        <h3>{{ $t("addAssigneeToCase") }}</h3>
        <div class="x-icon" @click="$emit('close')">
          <feather-icon size="16" icon="XIcon" />
        </div>
      </div>
      <div class="c-modal-body">
        <label class="input-label form-label">
          {{ $t("assignee") }} <span style="color: red">*</span>
        </label>
        <MultiSelectInput
          v-model="assignee"
          :options="modifiedUsers"
          :label="'full_name'"
          trackBy="id"
          :key="assignee"
          :required="true"
          :multiple="false"
          moduleName="users"
          :searchParamName="'search_string'"
          class="assignee-multiselect"
        >
          <template #option="{ props }">
            <div>
              <p>
                {{ props.option.first_name }} {{ props.option.last_name }}
              </p>
            </div>
          </template>
        </MultiSelectInput>
      </div>
      <div class="c-modal-footer d-flex align-items-center justify-content-end">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$emit('close')"
        >
          {{ $t("cancel") }}
        </button>
        <button type="button" class="btn btn-primary" @click="assignUser">
          {{ $t("assignUser") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MultiSelectInput from "@/components/MultiSelectInput.vue";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    caseId: {
      type: String,
      default: "",
    },
    assignedAssignee: {
      type: String,
      default: null,
    },
    
  },
  components: {
    MultiSelectInput,
  },
  data() {
    return {
      assignee: null,
    };
  },
  computed: {
    ...mapGetters("users", ["users"]),
    modifiedUsers() {
      if (!this.users || !Array.isArray(this.users)) {
        return [];
      }
      return this.users
        .filter((user) => {
          return user.roles && Array.isArray(user.roles) && user.roles.includes("admin");
        })
        .map((user) => ({
          ...user,
          full_name: `${user.first_name} ${user.last_name}`,
        }));
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.loadUsers();
        if (this.assignedAssignee) {
          this.$store.commit("showLoader", true);
          this.$store.dispatch("users/show", {
              id: this.assignedAssignee,
            }).then(response => {
              this.assignee = response?.data;
              this.assignee.full_name = `${this.assignee.first_name} ${this.assignee.last_name}`;
            }).finally(() => {
              this.$store.commit("showLoader", false);
            });
          } else{
            this.assignee = null;
            this.assignee.full_name = null;
          }
      }
    }
    
  },
  methods: {
    async loadUsers() {
      if (!this.users || !this.users.length) {
        await this.$store.dispatch("users/list");
      }
    },
    async assignUser() {
        if (!this.assignee) {
            return;
        }
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("caseLists/updateAssignee", {
            caseId: this.caseId,
            assignee: this.assignee?.id,
        });
        this.$emit("loadItems");
        this.$emit("close");
    },
  },
};
</script>

<style scoped>
.assignee-modal .c-modal-body {
  background: #fff;
  padding: 20px 20px 0 20px;
  max-height: calc(50vh - 210px);
  
}
.assignee-modal .c-modal-body .input-label {
  margin-bottom: 8px;
}
.assignee-modal .assignee-multiselect {
  position: relative;
  z-index: 1000;
  margin-bottom: 0;
}
.assignee-modal .c-modal-body > *:last-child {
  margin-bottom: 0;
}
.assignee-modal .c-modal-content {
  width: 600px;
  max-height: 50vh;
}
</style>
<style lang="scss">
body.dark-layout {
  .assignee-modal .c-modal-body {
    background: #011632;
  }
}
</style>

